/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        container: {
            position: 'relative'
        },
        favIcon: {
            position: 'absolute',
            variant: 'unstyled',
            top: '0px',
            left: '0px'
        },
        imageWrapper: {
            position: 'relative',
            marginBottom: 2
        },
        image: {
            ratio: 1,
            paddingBottom: 2
        },
        link: {
            display: 'block',
            textDecoration: 'none',
            _hover: {
                textDecoration: 'none'
            },
            _focusVisible: {
                boxShadow: 'sm'
            }
        },
        price: {},
        title: {
            fontWeight: 600
        },
        rating: {},
        variations: {}
    }),
    parts: [
        'container',
        'imageWrapper',
        'image',
        'price',
        'title',
        'rating',
        'variations'
    ]
}
